var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExplosion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7318 30.0004L59.6899 39.175L44.3452 39.9125L48.3498 54.0197L35.4797 46.0381L30 59.6899L24.5211 46.0381L11.651 54.0197L15.6548 39.9125L0.310059 39.175L12.2682 30.0004L0.310059 20.8258L15.6548 20.0883L11.651 5.98022L24.5211 13.9619L30 0.310059L35.4797 13.9619L48.3498 5.98022L44.3452 20.0883L59.6899 20.8258",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0003 13.317L33.0796 20.9881L40.3109 16.503L38.0612 24.4308L46.6835 24.8451L39.9636 30.0003L46.6835 35.1556L38.0612 35.5699L40.3109 43.4969L33.0796 39.0126L30.0003 46.6829L26.9219 39.0126L19.6897 43.4969L21.9394 35.5699L13.3171 35.1556L20.0371 30.0003L13.3171 24.8451L21.9394 24.4308L19.6897 16.503L26.9219 20.9881L30.0003 13.317Z",
    fill: "#A3C5EB",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplosion);
export default __webpack_public_path__ + "static/media/explosion.a9af8ffc.svg";
export { ForwardRef as ReactComponent };